export default __webpack_public_path__ + "static/media/cross.826da282.png";